/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { useQuery } from '@tanstack/react-query';
import { subscriptionLifecycleService } from '@/services/superadmin/subscription-lifecycle.service';
import { SubscriptionLifecycleDto } from '@/types/superadmin.types';
import { ApiError } from '@/services/api/types';

export const subscriptionLifecycleKeys = {
  all: ['subscription-lifecycle'] as const,
  lifecycle: () => [...subscriptionLifecycleKeys.all, 'data'] as const,
};

export function useSubscriptionLifecycle() {
  return useQuery<SubscriptionLifecycleDto, ApiError>({
    queryKey: subscriptionLifecycleKeys.lifecycle(),
    queryFn: subscriptionLifecycleService.getLifecycle,
    staleTime: 60 * 1000, // 1 minute
    retry: 1,
  });
}
